<template>
  <nav class="navbar navbar-expand-lg">
    <a href="./" class="navbar-brand"><img src="../assets/images/TS_logo_horz_wht_s.png" class="logo" alt="Tuff Shed Inc."></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <router-link to="/signature" class="nav-link nav-link--underline" active-class="nav-link--active">Signature Tool</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/projects" class="nav-link nav-link--underline" active-class="nav-link--active">Projects</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/templates" class="nav-link nav-link--underline" active-class="nav-link--active">Templates</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/store" class="nav-link nav-link--underline" active-class="nav-link--active">Tuff Shed Store</router-link>
      </li>
    </ul>
    </div>
  </nav>
</template>


<script>
export default {
  name: 'headerElement',
  data: function () {
    return {
      headerMsg: 'Marketing Tools'
    }
  }
}
</script>

<style lang="scss" scoped>
  .logo {
      max-width: 150px;
  }

  .navbar {
    background: $ts-color-dark-grey-2;
  }

  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
  }

  .navbar-toggler {
    border: none;
    top: 5px;
    position: relative;
    right: -10px;
  } 

  .navbar-message {
    display: inline-block;
    position: relative;
    top: 5px;
    margin-left: 0;
    color: $ts-color-white;
    font-weight: 300;
  }

  .navbar-nav {
    color: $ts-color-white;
    margin: 12px 0 0 50px;

    @media screen and (max-width: 768px) {
      margin: 12px 0 0 0;
    }
  }

  .nav-item {
    a {
      color: $ts-color-white;
    }
    
    a:hover,
    .nav-link--active {
      color: $ts-color-orange;
    }
  }

  .nav-item:after {
    display: inline-block;
  }

  .nav-link {
    padding: .5rem 2rem;

    /* link underline animation */
    &.nav-link--underline {
      display: inline;
      position: relative;
      overflow: hidden;
    }

    &.nav-link--underline:after {
      content: "";
      position: absolute;
      z-index: 1;
      right: 0;
      width: 0;
      bottom: -5px;
      background: $ts-color-orange;
      height: 2px;
      transition-property: width;
      transition-duration: 0.3s;
      transition-timing-function: ease-out;
    }

    &.nav-link--underline:hover:after,
    &.nav-link--underline:focus:after,
    &.nav-link--underline:active:after {
      left: 0;
      right: auto;
      width: 100%;
    }
  }
</style>
